import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChangePayPwd from '../../components/personal/ChangePayPwd';

class SetPayPwdAgain extends Component {
  constructor() {
    super();
    this.state = {
      pwd: ''
    }
  }
  pwdSureBack = (value) => {
    this.setState({
      pwd: value
    })
  }

  nextStep = () => {
    this.props.pwdAgainSuccess(this.state.pwd);
  }

  render () {
    return (
      <div>
        <ChangePayPwd
          title='再次输入支付密码'
          subTitle='&nbsp;'
          btnTitle='提交'
          pwdSureBack={this.pwdSureBack}
          nextStep={this.nextStep}>
        </ChangePayPwd>
      </div>
    )
  }
}

SetPayPwdAgain.propTypes = {
  pwdAgainSuccess: PropTypes.func,
}

export default SetPayPwdAgain;